import { Component } from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'

import { Checkbox, Form } from 'components/forms'
import { SaveButton } from 'components/buttons'
import { ModalFooter } from 'components/modal'
import DateSelect from 'components/date-select'

import { dateString, required } from 'lib/form-validation'

import { saveRegistry } from 'registry/actions'
import {
  getArrivalDate,
  getArrivalKnown,
  getExpectingChildren,
  getRegistryId,
} from 'registry/reducers'

class ArrivalDateForm extends Component {
  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
  }
  render() {
    const {
      fields: {
        registry: {
          family: { arrivalDate, isArrivalDateKnown },
        },
      },
      handleSubmit,
      submitting,
      numChildren,
    } = this.props

    return (
      <Form
        className="welcome--arrival-date-form"
        onSubmit={handleSubmit(this.handleSubmit)}
      >
        <DateSelect
          {...arrivalDate}
          onChange={this.handleArrivalDateChange.bind(this)}
          label="Arrival Date"
        />
        <Checkbox
          checked={isArrivalDateKnown.value === false}
          value={!isArrivalDateKnown.value}
          onChange={this.handleIsArrivalDateUnknownChange.bind(this)}
          label="I don't know (Adopting, trying to conceive, etc.)"
        />
        <ModalFooter>
          <SaveButton submitting={submitting} block />
        </ModalFooter>
      </Form>
    )
  }

  handleSubmit(values, dispatch) {
    const { isOpeningFromHBBGoalsModal } = this.props
    const {
      registry: {
        family: { isArrivalDateKnown, arrivalDate },
      },
    } = values
    if (isArrivalDateKnown) {
      const requiredVal = required(arrivalDate)
      const dateVal = dateString(arrivalDate)
      if (requiredVal || dateVal) {
        return Promise.reject({
          registry: { family: { arrivalDate: requiredVal || dateVal } },
        })
      }
    }
    if (isOpeningFromHBBGoalsModal) {
      return dispatch(saveRegistry(values, { redirectToHbbModal: true }))
    }

    return dispatch(saveRegistry(values))
  }

  handleArrivalDateChange(value) {
    const {
      fields: {
        registry: {
          family: { arrivalDate, isArrivalDateKnown },
        },
      },
    } = this.props
    if (!value) {
      isArrivalDateKnown.onChange(false)
    } else {
      isArrivalDateKnown.onChange(true)
    }
    arrivalDate.onChange(value)
  }

  handleIsArrivalDateUnknownChange(e) {
    const {
      fields: {
        registry: {
          family: { arrivalDate, isArrivalDateKnown },
        },
      },
    } = this.props
    if (e.target.checked) {
      arrivalDate.onChange(null)
    }
    isArrivalDateKnown.onChange(!e.target.checked)
  }
}

export default reduxForm(
  {
    form: 'arrivalDate',
    fields: [
      'registry.id',
      'registry.family.arrivalDate',
      'registry.family.isArrivalDateKnown',
    ],
  },
  (state, props) => {
    return {
      initialValues: {
        registry: {
          id: getRegistryId(state),
          family: {
            arrivalDate: getArrivalDate(state),
            isArrivalDateKnown: getArrivalKnown(state),
          },
        },
      },
      numChildren: getExpectingChildren(state).length,
    }
  }
)(ArrivalDateForm)

ArrivalDateForm.propTypes = {
  fields: PropTypes.shape({
    family: PropTypes.shape({
      arrivalDate: PropTypes.object,
      isArrivalDateKnown: PropTypes.object,
    }),
  }).isRequired,
  numChildren: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
}
